import { Tag } from '#app/components/ui/tag'

export default function AboutFundSection() {
	return (
		<section className="bg-white py-16 md:py-[96px]">
			<div className="container mx-auto max-w-[1200px] px-[37.5px] md:px-4">
				<div className="flex flex-col gap-8 md:gap-14">
					<div>
						<Tag
							variant="secondary"
							appearance="solid"
							color="blue"
							size="l"
							option="text-icon-left"
							leftIcon="service"
						>
							Proyecto
						</Tag>
					</div>

					<div className="flex flex-col gap-8 md:flex-row md:gap-8">
						{/* Title */}
						<div className="md:w-[488px]">
							<h2 className="font-parkinsans text-[40px] leading-[50px] font-medium text-blue-900 md:text-[56px] md:leading-[70px]">
								¿Qué es el{' '}
								<span className="text-green-600">Fondo de agua?</span>
							</h2>
						</div>

						{/* Description */}
						<div className="md:w-[696px]">
							<p className="font-inter text-base leading-[26px] text-gray-600">
								El Fondo de Agua del Río Mendoza, creado en 2022, es el primer
								fondo de agua de Argentina. Es una alianza pionera que une a
								actores públicos, privados y de la sociedad civil para
								garantizar la seguridad hídrica de la cuenca del río Mendoza,
								que abastece a más de un millón de personas. Frente al estrés
								hídrico que enfrenta la región, el fondo impulsa soluciones
								basadas en la naturaleza y la ciencia para mejorar la calidad y
								disponibilidad del agua.
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}
